import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { AppMainComponent } from "src/app/app.main.component";
import * as _ from "lodash";
import { ConfirmationService, MessageService } from "primeng/api";
import { DatePipe, TitleCasePipe } from "@angular/common";
import { AppMainService } from "src/app/app-main.service";
import { CustomAttributeFieldType, SOChannel, SoStageId, TaxCountry, TemplateType, TypeIds } from "src/app/inventory/sales-order/constants/constants";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { ProductsService } from "src/app/inventory/products/products.service";
import { SalesOrderStatus } from "src/app/inventory/constants/constants";
import { AccountsTransactionType, TransactionNames } from "src/app/finance/constants/constants";
import { ReceivedPaymentRequestBuilderService } from "src/app/inventory/sales-order/services/received-payment-request-builder.service";
import { ImportserialService } from "../../services/importserial.service";
import { Subject, takeUntil } from "rxjs";
import { ApprovalTypeInfo } from "../../model/approval/approval-info";
import { ApprovalType } from "../../enums/approval/approval.enum";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: "app-sales-order-overview",
    templateUrl: "./sales-order-overview.component.html",
    styleUrls: ["./sales-order-overview.component.scss"],
})
export class SalesOrderOverviewComponent implements OnChanges {
    @Input() salesOrderDetails;
    @Input() allShippingMethods;
    @Input() showOrderVoidMsg;
    @Input() vendorFedexInfo;
    @Input() fedexAccountInfo;
    @Input() allFedexAccounts;
    @Input() vendorUpsInfo;
    @Input() allUpsAccounts;
    @Input() visibleFromModule;
    @Input() templates;
    @Input() isEnabledBackOrder;

    @Output() onInvoiceCreate = new EventEmitter();
    @Output() onLabelCreate = new EventEmitter();
    @Output() onVoidShipment = new EventEmitter();
    @Output() onViewLabel = new EventEmitter();
    @Output() onFedexLabelCreate = new EventEmitter();
    @Output() onFedexVoidShipment = new EventEmitter();
    @Output() onFedexTrackShipment = new EventEmitter();
    @Output() onUpsShipment = new EventEmitter();
    @Output() onUpsVoidShipment = new EventEmitter();
    @Output() onUpsViewLabel = new EventEmitter();
    // @Output() onUpsTrackShipment = new EventEmitter();
    @Output() onAccountView = new EventEmitter();
    @Output() refreshEmitter = new EventEmitter();

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    billingAddress;
    shippingAddress;
    billingAddressContact;
    shippingAddressContact;
    cols = 0;
    footerlabelColSpan = 0;
    footerValueColSpan = 0;
    customFields = {
        billing_address_item: [],
        shipping_address_item: [],
        misc_item: [],
        section_item: [],
        footer_item: [],
        message_item: [],
        other1_item: [],
        other2_item: [],
        other3_item: [],
    };
    fieldTypes = CustomAttributeFieldType;
    displayShipmentDialog = false;
    isVisibleCreateLabel = true;
    paidStatus = 3;
    displayInvoiceHistory = false;
    channel = "SALESORDER";
    invoiceHisotry = [
        {
            id: 1,
            date: "02/22/22, 9:03 AM",
            message: "$800.00 received from ABC Corp",
            user: "xitij",
        },
        {
            id: 2,
            date: "02/25/22, 9:03 AM",
            message: "$Invoice created",
            user: "taylor",
        },
    ];
    trackingDetails = [];
    notMatchedTrackingDetails = [];
    soStage = SoStageId;
    selectedCarrier;
    isVisibleCarrier = true;
    shippingCarriers = [];
    today = new Date();
    voidDate: string;
    shipMessage = "";
    allCustomAttributes = [];
    allModules = [];
    orderObjId;
    discounts = [];
    purchaseList = [];
    // templates;
    selectedOrdersStageId;
    soDetailsCustomFields;
    showPickColumn;
    soChannel = SOChannel;
    expandedRows: {} = {};
    sanitizedHtml: SafeHtml;

    showTaxBasedSplitView = false;
    isStateMatched = false;
    addBtnInfoTooltip = "";
    soStatus = SalesOrderStatus;
    displayAppliedAmountViewModal = false;
    soDetails: any = null;
    totalAmount: number = 0;
    productsTotalAdditionalAmount: number = 0;
    filteredSection: any[] = [];

    //Inventory Overview
    transactionNames = TransactionNames;
    displayInventoryOverview: boolean = false;
    inventoryOverviewRefId: number = 0;
    inventoryOverviewRefNumber: string = "";
    inventoryOverviewModule: string = "";

    // credit memo selection
    displayCreditSelect: boolean = false;
    creditAppliedTotal: number = 0;
    totalCreditAmount: number = 0;
    selectedCredits: any[] = [];
    shouldreloadCreditMemos: boolean = false;

    // fedex
    selectedFedexAcc;

    // fraction digits
    fractionDigits: number = 0;
    qtyFractionDigits: number = 0;

    /** Approval */
    displayViewApproval: boolean = false;
    approvalTypeInfo: ApprovalTypeInfo;

    // currency
    baseCurrency: any;
    orgCurrency = [];
    savedCurrencyExchangeRate: any;
    savedCurrencyUnit: any;

    transactionTypeIds = AccountsTransactionType;
    glApiCall: boolean = false;
    soId: number;

    constructor(
        public app: AppMainComponent,
        private confirmationService: ConfirmationService,
        private utilityService: UtilityService,
        private datePipe: DatePipe,
        private salesOrderService: SalesOrderService,
        private messageService: MessageService,
        private titlecasePipe: TitleCasePipe,
        private appMainService: AppMainService,
        private productsService: ProductsService,
        private receivedPaymentRequestBuilderService: ReceivedPaymentRequestBuilderService,
        private importService: ImportserialService,
        private sanitizer: DomSanitizer,
    ) {}

    ngOnInit() {
        this.getFractionDigits();
        this.getQtyDecimalDigits();
        this.getBaseCurrency();
        this.allModules = this.app.preLoadedObjects.filter((obj) => obj.name == "Orders");
        this.orderObjId = this.allModules.find((el) => el.name == "Orders")?.id;
        this.getAllCustomAttributes();
        this.utilityService.getFilteredSectionsByType(0).subscribe((res) => {
            this.filteredSection = res;
        });

        this.salesOrderService.getAllOrdersChannel("Orders Template").subscribe((configs) => {
            let allTemplates = JSON.parse(configs.configurationDetails[0].configJSONValue);
            this.templates = allTemplates?.filter((t) => t.typeId == TemplateType.SalesOrder)[0];
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.salesOrderDetails && changes.salesOrderDetails.currentValue) {
            this.isVisibleCreateLabel = true;
            this.shouldreloadCreditMemos = true;
            this.soId = this.salesOrderDetails.id;
            this.salesOrderDetails = changes.salesOrderDetails.currentValue;
            this.prepareSalesOrderDetailsData();
        }
        if (changes.allShippingMethods && changes.allShippingMethods.currentValue) {
            this.allShippingMethods = changes.allShippingMethods.currentValue;
            this.shippingCarriers = this.allShippingMethods.filter((s) => s.isAPIConfigured == true);
            this.selectedCarrier = this.allShippingMethods.filter((s) => s.isDefault == true)[0];
        }
        this.getColsCount();
        this.shipMessage = "";
        this.voidDate = this.datePipe.transform(Date.now(), "MM-dd-yyyy");

        if(this.allFedexAccounts && this.allFedexAccounts?.length > 0){
            this.selectedFedexAcc = this.allFedexAccounts?.find((a) => a.isDefault == true);
        }
    }

    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if (value) {
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }
    getQtyDecimalDigits() {
        this.importService
            .getQtyDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.qtyFractionDigits = value;
                }
            });
    }
    getBaseCurrency() {
        this.importService
            .getOrgCurrency()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.baseCurrency = value.find((cr) => cr.isBaseCurrency);
                    this.orgCurrency = value;
                }
            });
    }

    prepareSalesOrderDetailsData() {
        this.salesOrderService.getAllGroups().subscribe((res) => {
            const disGroupId = res.filter((r) => r?.name?.toLowerCase() == "discount type")[0].id;
            this.salesOrderService.getDiscounts(false).subscribe((res) => {
                this.discounts = res;
                this.parseSoDetailsData();
            });
        });
    }
    parseSoDetailsData() {
        this.salesOrderDetails.salesOrderDate = this.salesOrderDetails.salesOrderDate ? this.app._showDateTimeWithZone(this.salesOrderDetails?.salesOrderDate) : "";
        this.billingAddress = this.salesOrderDetails?.account?.accountAddresses?.filter((d) => d.addressId == this.salesOrderDetails.billingAddressId)[0];
        this.shippingAddress = this.salesOrderDetails?.account?.accountAddresses?.filter((d) => d.addressId == this.salesOrderDetails.shippingAddressId)[0];
        this.billingAddressContact = this.salesOrderDetails?.contact;
        this.shippingAddressContact = this.salesOrderDetails?.shipContact;
        this.savedCurrencyExchangeRate = Number(this.salesOrderDetails.exchangeRate);
        this.savedCurrencyUnit = this.salesOrderDetails.account?.currencyUnit;

        if (this.salesOrderDetails?.shipment && this.salesOrderDetails?.shipment.length) {
            const d = this.salesOrderDetails?.shipment.filter((s) => s.statusId == 1 || s.statusId == 2)[0]; // label created or void submitted
            this.isVisibleCreateLabel = d ? false : true;
        }

        this.selectedOrdersStageId = this.salesOrderDetails.salesOrderStageId;
        this.showPickColumn = this.selectedOrdersStageId == SoStageId.Entered ? false : true;
        this.templates = this.salesOrderDetails && this.salesOrderDetails.configJSON ? JSON.parse(this.salesOrderDetails.configJSON) : this.templates;
        this.customFields = this.utilityService.getCustomAttributesForCommon(this.templates, this.allCustomAttributes);
        this.purchaseList = this.utilityService.parseSoProductsListForOverview(this.salesOrderDetails, this.discounts);
        this.purchaseList.forEach((element) => {
            if (element.typeId == TypeIds.BundleTypeId) {
                let total = 0;
                if (element?.salesOrderBundleDetail && element?.salesOrderBundleDetail?.length) {
                    element?.salesOrderBundleDetail?.forEach((e) => {
                        total += e.amount;
                    });
                }
                element.amount = total;
            }
        });
        this.trackingDetails = this.utilityService.getSalesOrderProductsSerialDetails(this.purchaseList);
        this.notMatchedTrackingDetails = this.salesOrderDetails.notMatchedSerialNumbers;
        this.setAddBtnToolTipText();

        // populate saved custom field data
        if (this.salesOrderDetails.customAttributeValues && this.salesOrderDetails.customAttributeValues.length) {
            Object.keys(this.customFields).forEach((key) => {
                const dataArr = this.customFields[key];
                if (dataArr && dataArr.length > 0) {
                    dataArr.forEach((element) => {
                        const filteredCustom = this.salesOrderDetails.customAttributeValues.filter((c) => c.customAttributeId == element.id)[0];
                        if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "InputBox") {
                            element.value = filteredCustom.value;
                        } 
                        else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Decimal") {
                            element.value = filteredCustom.value;
                        } 
                        else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Number") {
                            element.value = filteredCustom.value;
                        } 
                        else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
                            element.value = this.datePipe.transform(filteredCustom.value, "MM/dd/yyyy");
                        } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
                            element.customUploadedFiles = [];
                            filteredCustom.customeAttachement.forEach((el) => {
                                element.customUploadedFiles.push(el);
                            });
                        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
                            element.value = filteredCustom.ratingId;
                        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
                            element.value = filteredCustom.toggle;
                        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
                            element.value = filteredCustom.values;
                        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
                            element.value = filteredCustom.values.name;
                        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
                            element.value = [];
                            filteredCustom.multipleValues.forEach((el) => {
                                element.value.push(el.name);
                            });
                        } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
                            element.value = [];
                            filteredCustom.multipleValues.forEach((el) => {
                                element.value.push(el);
                            });
                        }
                    });
                }
            });
        }

        this.soDetails = _.cloneDeep(this.salesOrderDetails);
        this.checkCountryToShowSplitView();
        this.calculateTotalAmount();
        this.calculateProductsTotalAdditionalAmount();
    }
    calculateTotalAmount() {
        this.totalAmount = this.soDetails?.salesOrderProducts?.reduce((total, item) => total + Number(item?.totalAmount), 0);
    }

    calculateProductsTotalAdditionalAmount() {
        const getAdditionalAmount = (item) => {
            let total = item?.product?.typeId == 4 ? 0 : Number(item?.additionalAmount) || 0;
            if (item?.salesOrderBundleDetail && item.salesOrderBundleDetail?.length > 0) {
                total += item.salesOrderBundleDetail.reduce((sum, bundleItem) => {
                    return sum + getAdditionalAmount(bundleItem);
                }, 0);
            }
            return total;
        };
    
        this.productsTotalAdditionalAmount = this.soDetails?.salesOrderProducts?.reduce((total, item) => {
            return total + getAdditionalAmount(item);
        }, 0) || 0;
    }

    setAddBtnToolTipText() {
        if (this.selectedOrdersStageId == SoStageId.Pick) {
            this.addBtnInfoTooltip = "Pick Slip";
        } else if (this.selectedOrdersStageId == SoStageId.Pack) {
            this.addBtnInfoTooltip = "Pack Slip";
        } else {
            this.addBtnInfoTooltip = "";
        }
    }

    checkCountryToShowSplitView() {
        if (this.shippingAddress?.address?.countryId == TaxCountry.India) {
            if (this.shippingAddress?.address?.countryId == this.soDetails?.warehouse?.address?.countryId && this.shippingAddress?.address?.state?.name?.toLowerCase() == this.soDetails?.warehouse?.address?.state?.name?.toLowerCase()) {
                this.isStateMatched = true;
            } else {
                this.isStateMatched = false;
            }
            this.showTaxBasedSplitView = true;
        } else {
            this.showTaxBasedSplitView = false;
        }
    }

    getFormattedData(field) {
        if (field && field?.value && field?.value.length > 0) {
            let d = "";
            field.value.forEach((f) => {
                d += f.name + ",";
            });
            return d.substring(0, d.length - 1);
        } else {
            return "";
        }
    }

    createInvoiceTB() {
        this.onInvoiceCreate.emit({});
    }

    createLabel(e) {
        this.displayShipmentDialog = false;
        this.onLabelCreate.emit(e);
    }

    createFedexLabel(e) {
        this.displayShipmentDialog = false;
        this.onFedexLabelCreate.emit(e);
    }

    onSuccessfullUpsShipment(e) {
        this.displayShipmentDialog = false;
        this.onUpsShipment.emit(e);
    }

    voidShipment(e) {
        this.confirmationService.confirm({
            message: "Do you want to void this Shipment?",
            header: "Void Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                if (e.trackingLink == "FEDEX") {
                    this.onFedexVoidShipment.emit(e);
                } else if (e.trackingLink == "UPS") {
                    this.onUpsVoidShipment.emit(e);
                } else {
                    this.onVoidShipment.emit(e);
                }
            },
            reject: () => {},
        });
    }

    trackFedexShipment(trackingNo) {
        this.onFedexTrackShipment.emit(trackingNo);
    }

    trackUpsShipment(trackingNo) {
        this.salesOrderService.trackUpsShipment(trackingNo, this.vendorUpsInfo?.id).subscribe(
            (res) => {
                this.shipMessage = res.trackResponse?.shipment[0]?.package[0]?.activity[0]?.status?.description || "";
            },
            (e) => {
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: e?.error,
                });
            },
        );
    }

    getAllCustomAttributes() {
        this.appMainService.isShowSpinner("loadCustomAttributes");
        this.productsService.getAllCustomFields(this.orderObjId).then((fields) => {
            this.allCustomAttributes = _.cloneDeep(fields);
            this.appMainService.isHideSpinner("loadCustomAttributes");
        });
    }

    getAllGroup() {
        this.salesOrderService.getAllGroups().subscribe((res) => {
            const disGroupId = res.filter((r) => r?.name?.toLowerCase() == "discount type")[0].id;
            this.getAllDiscountByGroupId(disGroupId);
        });
    }

    getAllDiscountByGroupId(groupId) {
        this.salesOrderService.getGroupById(groupId).subscribe((res) => {
            this.discounts = res;
        });
    }

    getColsCount() {
        this.cols = 0;
        this.footerValueColSpan = 2;
        if (this.templates && this.templates.labels_table) {
            this.templates.labels_table.forEach((e) => {
                this.cols += e && e.isChecked ? 1 : 0;
            });
        }
        if (this.salesOrderDetails?.salesOrderStageId == SoStageId.Entered) {
            this.cols -= 4;
            this.footerValueColSpan = 1;
        } else if (this.salesOrderDetails?.salesOrderStageId == SoStageId.Pick) {
            this.cols -= 3;
        } else if (this.salesOrderDetails?.salesOrderStageId == SoStageId.Pack || this.salesOrderDetails?.salesOrderStageId == SoStageId.Verification || this.salesOrderDetails?.salesOrderStageId == SoStageId.Labelling || this.salesOrderDetails?.salesOrderStageId == SoStageId.ReadyToShip) {
            this.cols -= 2;
        } else if (this.salesOrderDetails?.salesOrderStageId == SoStageId.Shipped) {
            this.cols -= 1;
            if (!this.isEnabledBackOrder) {
                this.cols -= 1;
            }
        }
    }

    showShipmentDialog() {
        if (this.allShippingMethods && this.allShippingMethods.length) {
            this.shippingCarriers = this.allShippingMethods.filter((s) => s.isAPIConfigured == true);
            this.selectedCarrier = this.allShippingMethods.filter((s) => s.isDefault == true)[0];
        }
        this.displayShipmentDialog = true;
        this.isVisibleCarrier = true;
    }

    onShipmentDialogClose() {
        this.selectedCarrier = null;
        this.displayShipmentDialog = false;
        this.isVisibleCarrier = false;
    }

    showInvoiceHistory() {
        this.displayInvoiceHistory = true;
    }

    viewLabelPdf(e) {
        if (e.trackingLink == "UPS") {
            this.onUpsViewLabel.emit(e);
        } else {
            this.onViewLabel.emit(e?.labelLink);
        }
    }

    onChangeCarrier() {}

    onStepChange(e) {
        this.isVisibleCarrier = e;
    }

    onAccountViewClick(e) {
        this.onAccountView.emit({ id: e?.account?.id ?? 0, channelId: e?.channelId });
    }

    onAppliedAmountViewClick() {
        this.displayAppliedAmountViewModal = true;
    }

    onCloseAppliedAmountModal() {
        this.displayAppliedAmountViewModal = false;
    }

    navigateToInvoice(e) {
        this.inventoryOverviewRefId = e.invoiceId;
        this.inventoryOverviewRefNumber = e.invoiceNo;
        this.inventoryOverviewModule = TransactionNames.Invoice;
        this.displayInventoryOverview = true;
    }
    navigateToEstimate(e) {
        this.inventoryOverviewRefId = e.estimateId;
        this.inventoryOverviewRefNumber = e.estimateNo;
        this.inventoryOverviewModule = TransactionNames.Estimate;
        this.displayInventoryOverview = true;
    }
    closeViewPopup() {
        this.displayInventoryOverview = false;
    }

    /** Credit Memo Selection */
    displayCreditMemoSelectionModal() {
        this.displayCreditSelect = true;
        this.shouldreloadCreditMemos = true;
    }
    onCloseCreditMemoSelectionModal(e) {
        this.displayCreditSelect = false;
        this.shouldreloadCreditMemos = false;
    }
    onApplyCreditMemo(event: any) {
        this.creditAppliedTotal = (event.appliedCreditMemoTotal)?.toFixed(this.fractionDigits);
        this.totalCreditAmount = (event.totalCreditAmount)?.toFixed(this.fractionDigits);
        this.selectedCredits = event.selectedCredits;
        this.shouldreloadCreditMemos = false;
        if (event.type == "apply") {
            this.displayCreditSelect = false;
            let data = {
                app: this.app,
                detailsData: this.soDetails,
                selectedCredits: this.selectedCredits,
                channel: SOChannel.SALES_ORDER,
                receivedPayment: event.receivedPayment,
            };
            let receivedPaymentRequestData = this.receivedPaymentRequestBuilderService.prepareReceivedPaymentRequestData(data);
            if (event?.receivedPayment) {
                this.updateReceivedPayment(receivedPaymentRequestData);
            } else {
                this.createReceivedPayment(receivedPaymentRequestData);
            }
        }
    }
    createReceivedPayment(receivedPaymentRequestData) {
        this.appMainService.isShowSpinner("payment");
        this.salesOrderService
            .createReceivedPAyment(receivedPaymentRequestData)
            .then(() => {
                this.appMainService.isHideSpinner("payment");
                this.refreshEmitter.emit({ refresh: true });
            })
            .catch((e) => {
                this.appMainService.isHideSpinner("payment");
            });
    }
    updateReceivedPayment(receivedPaymentRequestData) {
        this.appMainService.isShowSpinner("payment");
        this.salesOrderService
            .updateReceivedPayment(receivedPaymentRequestData)
            .then(() => {
                this.appMainService.isHideSpinner("payment");
                this.refreshEmitter.emit({ refresh: true });
            })
            .catch((e) => {
                this.appMainService.isHideSpinner("payment");
            });
    }

    // find section by code
    getFilteredSectionsByType(code: string): string {
        return this.filteredSection?.find((s) => s.code == code)?.name ?? "";
    }

    /** Approval Details */
    showApprovalDetails(salesOrder) {
        this.approvalTypeInfo = {
            approvalType: ApprovalType.SalesOrderApproval,
            approvalTypeId: salesOrder.id,
            approvalTypeNumber: salesOrder.number,
            status: "1",
        };
        this.displayViewApproval = true;
    }
    handleApprovalStatus(isUpdate: boolean) {
        if (isUpdate) {
            this.refreshEmitter.emit({ refresh: true });
        }
    }

    onTabChange(event){
        if(event.index == 1){
            this.glApiCall = true;
        }
        else{
            this.glApiCall = false;
        }
    }

    getSanitizedHtml(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
